import styled from 'styled-components';

export default styled.h2`
  all: initial;
  color: #404040 !important;
  font-weight: 500 !important;
  font-size: 15px !important;
`;
